// extracted by mini-css-extract-plugin
export default {"button":"button-JeZa","icon":"icon-yhAy","select":"select-U4Ec"};